var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-links"},[(_vm.tags.length !== 0)?_c('ul',{staticClass:"tag-links__items"},_vm._l((_vm.tags),function(tag){return _c('li',{key:tag,staticClass:"tag-links__item"},[_c('a',{staticClass:"tag-links__item-link",attrs:{"href":`/users/tags/${encodeURIComponent(tag)}`}},[_vm._v(_vm._s(tag))])])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }